import { Chip, Tooltip } from "@gpstrackit/react-controls";
import cx from "classnames";
import "./chipstatus.scss";

const ChipStatus = (props) => {
    const { statusCode, width, messages, label, showTooltip, className } = props;
    const codes = {
        0: messages ? messages['desactivated'] : "Desactivated",
        1: messages ? messages['active'] : "Active",
        2: messages ? messages['voluntary_suspension'] : "Voluntary Suspension",
        3: messages ? messages['involuntary_suspension'] : "Involuntary Suspension",
        4: messages ? messages['cancelled'] : "Cancelled",
        6: messages ? messages['rma'] : "RMA",
        20: messages ? messages['inactive'] : "Inactive",
    }
    const displayLabel = (label && messages && messages[label]) ? messages[label] : (label || codes[statusCode || 0]);
    if (!showTooltip) {
        return (
            <div className={cx("chip-status", label === "Active" || label === "Activo" || statusCode !== 1 && "chip-container", className)} style={{ width: width || '100px', textAlign: 'center' }}>
                <Chip label={displayLabel} />
            </div>

        )
    }
    else {
        return (
            <Tooltip title={displayLabel}>
                <div className={cx("chip-status", label === "Active" || label === "Activo" || statusCode !== 1 && "chip-container", className)} style={{ width: width || '100px', textAlign: 'center' }}>
                    <Chip label={displayLabel} />
                </div>
            </Tooltip>
        )
    }
}

export default ChipStatus